module.exports = {"441623100":"元善镇","441623101":"上坪镇","441623102":"内莞镇","441623104":"陂头镇","441623105":"溪山镇","441623107":"隆街镇","441623108":"田源镇","441623109":"油溪镇","441623110":"忠信镇","441623111":"高莞镇","441623113":"大湖镇","441623114":"三角镇","441623115":"绣缎镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/441623.json
// module id = 1865
// module chunks = 0